import { render, staticRenderFns } from "./TiExpertiseSlider.vue?vue&type=template&id=e4d2dd20&"
import script from "./TiExpertiseSlider.vue?vue&type=script&lang=js&"
export * from "./TiExpertiseSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
